<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="300px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ $t('Prašome pasirinkti dokumento kalbą') }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row class="mb-0 pb-0">
          <v-col class="pb-0 pt-3" cols="12">
            <el-autocomplete
              required
              :items="enumsClassifiers.bilingualMandate"
              enums
              itemvalue="value"
              itemtext="text"
              tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Dokumento kalba"
              :label="mandate ? 'Įgaliojimo dokumento kalba' : 'Dokumento kalba'"
              v-model="bilingual"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          title="Atgal"
          :loading="loading"
          @click.native.stop="closeModal()"
          color="secondary"
        />
        <el-button
          title="Tęsti"
          :loading="loading"
          @click.native="confirmData()"
          color="primary"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import errorNotifications from '@/mixins/errorNotifications'
import Enums from '@/enums'

export default {
  name: 'ModalMandateLanguage',
  mixins: [errorNotifications],
  props: {
    value: Boolean,
    loading: Boolean,
    selected: String,
    mandate: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      enumsClassifiers: [],
      bilingual: null,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    this.enumsClassifiers = Enums
    this.modalloading = false
    this.setParamByLang()
  },
  methods: {
    setParamByLang(){
    if(this.selected == "0" || this.selected == "1"){
      this.bilingual = this.selected
    } else {
      this.bilingual = this.$i18n.locale === 'lt' ? "0" : "1"
    }
     
    },
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
    confirmData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.$emit('confirmData', this.bilingual)
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
